import { render, staticRenderFns } from "./dashboard-live-clock.vue?vue&type=template&id=9ea4dff2"
import script from "./dashboard-live-clock.vue?vue&type=script&lang=js"
export * from "./dashboard-live-clock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports